import { FC, PropsWithChildren } from 'react';
import { FooterContainer, HeaderContainer } from './Panel.styled';

export const PanelHeader: FC<React.PropsWithChildren> = ({ children, ...props }) => {
  return <HeaderContainer {...props}>{children}</HeaderContainer>;
};

export const PanelFooter: FC<PropsWithChildren> = ({ children, ...props }) => {
  return <FooterContainer {...props}>{children}</FooterContainer>;
};
